import { AxiosResponse } from 'axios';
import { API_URLS } from '../../../constants/urls/api-urls';
import { postData } from '../../../utils/fetch-api-util';
import { Token, TokenRepository } from '../../web-storage/token';

export type LoginPayload = {
  email: string;
  password: string;
};

export type LoginResponse = {
  idToken: string;
  refreshToken: string;
  expiresIn: number;
  role: number;
};

export const postLoginRepository = (data: LoginPayload): Promise<AxiosResponse<LoginResponse>> => {
  return postData(API_URLS.LOGIN, data, undefined, process.env.REACT_APP_LOGIN_ADMIN_PORTAL_CLIENT_ID);
};

export const mutateLoginRepository = async (mutate: any, data: LoginPayload): Promise<AxiosResponse<LoginResponse>> => {
  const response: AxiosResponse<LoginResponse> = await mutate(API_URLS.LOGIN, postLoginRepository(data));
  const result: Token = {
    idToken: response.data.idToken,
    refreshToken: response.data.refreshToken,
    expiresIn: response.data.expiresIn,
    role: Number(response.data.role),
  };
  TokenRepository.setToken(result);
  return response;
};
